import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import nft1 from '../assets/images/collection/1.png';
import nft2 from '../assets/images/collection/2.webp';
import nft3 from '../assets/images/collection/3.png';
import nft4 from '../assets/images/collection/4.webp';
import nft5 from '../assets/images/collection/5.png';
import React from "react";

export const SwiperGallery = () => {
    const settings = {
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "20px",
        autoplay: true,
        autoplaySpeed: 3000,
        pauseOnHover: true,
        adaptiveHeight: true,
    };
    return (
        <div className="slider-container">
            <Slider {...settings}>
                <div className="p-1">
                    <img className="z-0 object-contain" src={nft1} alt=""/>
                </div>
                <div className="p-1">
                    <img className="z-0 " src={nft2} alt=""/>
                </div>
                <div className="p-1">
                    <img className="z-0 " src={nft3} alt=""/>
                </div>
                <div className="p-1">
                    <img className="z-0 object-contain" src={nft4} alt=""/>
                </div>
                <div className="p-1">
                    <img className="z-0 object-contain" src={nft5} alt=""/>
                </div>
            </Slider>
        </div>
    );
};
